module.exports = __webpack_public_path__ + "static/img/updateNotify.0c16427b.png";